module.exports = {"apiBase":"/v1","wsBase":"/v1"}


//////////////////
// WEBPACK FOOTER
// ./config/default.json
// module id = 2389
// module chunks = 1